import axios from './axios';

const getChatSessions = async (filters = {}, options = {}) => {
	console.log('Fetching chat sessions with:', { filters, options }); // Debug

	const params = {
		...filters,
		page: options.page,
		limit: options.limit,
		sortBy: options.sortBy,
	};

	console.log('Final params:', params); // Debug

	const response = await axios.get('/chatSessions', { params });
	return response;
};

const getChatSession = async (id) => {
	const response = await axios.get(`/chatSessions/${id}`);
	return response;
};

const updateChatSession = async (id, data) => {
	const response = await axios.put(`/chatSessions/${id}`, data);
	return response;
};

const deleteChatSession = async (id) => {
	const response = await axios.delete(`/chatSessions/${id}`);
	return response;
};

const getTokens = () => {
	try {
		const loggedUserJSON = window.localStorage.getItem('loggedUser');
		if (!loggedUserJSON) return null;
		return JSON.parse(loggedUserJSON).tokens;
	} catch (error) {
		console.error('Error getting tokens:', error);
		return null;
	}
};

const baseUrl = import.meta.env.VITE_BASE_URL;

// Uusi: POST + SSE stream reader
const sendMessageStream = async (message) => {
	const tokens = getTokens();
	const headers = {
		'Content-Type': 'application/json',
	};
	if (tokens?.access?.token) {
		headers['Authorization'] = `Bearer ${tokens.access.token}`;
	}
	const response = await fetch(`${baseUrl}/v1/conversations`, {
		method: 'POST',
		headers,
		body: JSON.stringify({ message }),
	});
	if (!response.body) throw new Error('No response body for SSE stream!');
	return response.body.getReader();
};

const expressInterest = async (sessionId, talentId, notes) => {
	try {
		console.log('Expressing interest:', { sessionId, talentId, notes });
		const response = await axios.post(
			`/chatSessions/${sessionId}/talents/${talentId}/interest`,
			{ notes },
		);
		console.log('Express interest response:', response);
		return response;
	} catch (error) {
		console.error('Error in chatSessionService expressInterest:', error);
		throw error;
	}
};

export default {
	getChatSessions,
	getChatSession,
	updateChatSession,
	deleteChatSession,
	sendMessageStream,
	expressInterest,
};
